import React, { useEffect, useRef, useState } from 'react';
import { findParentNode, posToDOMRect } from '@tiptap/core';
import { useCurrentEditor, useEditorState } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';
import LinkMenu from './LinkMenu';

const LinkBubbleMenu = () => {
	const bubbleRef = useRef();

	const { editor } = useCurrentEditor();

	const { hasLink, link } = useEditorState({
		editor,
		selector: (ctx) => ({
			link: ctx.editor?.getAttributes('link')?.href ?? '',
			hasLink: ctx.editor?.isActive('link'),
		}),
	});

	const [url, setUrl] = useState(link);
	const inputRef = useRef(null);

	useEffect(() => setUrl(link), [link]);

	const handleSubmit = () => {
		if (!url) {
			editor.chain().focus().unsetLink().run();
			return;
		}

		editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
	};

	if (!editor) return <></>;

	return (
		<BubbleMenu
			editor={editor}
			ref={bubbleRef}
			shouldShow={({ editor }) => editor?.isActive('link')}
			getReferencedVirtualElement={() => {
				const parentNode = findParentNode((node) => node.type.name === 'link')(
					editor.state.selection
				);
				if (parentNode) {
					const domRect = posToDOMRect(
						editor.view,
						parentNode.start,
						parentNode.start + parentNode.node.nodeSize
					);
					return {
						getBoundingClientRect: () => domRect,
						getClientRects: () => [domRect],
					};
				}
				return null;
			}}
			options={{ placement: 'top-start', offset: 8 }}
		>
			<LinkMenu
				{...{
					url,
					setUrl,
					inputRef,
					onSubmit: handleSubmit,
					onRemove: () => {
						editor.chain().focus().unsetLink().run();
					},
					isActive: hasLink,
				}}
			/>
		</BubbleMenu>
	);
};

export default LinkBubbleMenu;
